"use client";
import {
  useAutocomplete
} from "./chunk-SYFYBWAI.mjs";

// src/autocomplete.tsx
import { forwardRef } from "@nextui-org/system";
import { FreeSoloPopover } from "@nextui-org/popover";
import { ScrollShadow } from "@nextui-org/scroll-shadow";
import { ChevronDownIcon, CloseIcon } from "@nextui-org/shared-icons";
import { Listbox } from "@nextui-org/listbox";
import { Button } from "@nextui-org/button";
import { Input } from "@nextui-org/input";
import { AnimatePresence } from "framer-motion";
import { jsx, jsxs } from "react/jsx-runtime";
function Autocomplete(props, ref) {
  const {
    Component,
    state,
    isOpen,
    disableAnimation,
    selectorIcon = /* @__PURE__ */ jsx(ChevronDownIcon, {}),
    clearIcon = /* @__PURE__ */ jsx(CloseIcon, {}),
    endContent,
    getBaseProps,
    getSelectorButtonProps,
    getInputProps,
    getListBoxProps,
    getPopoverProps,
    getEmptyPopoverProps,
    getClearButtonProps,
    getListBoxWrapperProps,
    getEndContentWrapperProps
  } = useAutocomplete({ ...props, ref });
  const popoverContent = isOpen ? /* @__PURE__ */ jsx(FreeSoloPopover, { ...getPopoverProps(), state, children: /* @__PURE__ */ jsx(ScrollShadow, { ...getListBoxWrapperProps(), children: /* @__PURE__ */ jsx(Listbox, { ...getListBoxProps() }) }) }) : /* @__PURE__ */ jsx("div", { ...getEmptyPopoverProps() });
  return /* @__PURE__ */ jsxs(Component, { ...getBaseProps(), children: [
    /* @__PURE__ */ jsx(
      Input,
      {
        ...getInputProps(),
        endContent: /* @__PURE__ */ jsxs("div", { ...getEndContentWrapperProps(), children: [
          endContent || /* @__PURE__ */ jsx(Button, { ...getClearButtonProps(), children: clearIcon }),
          /* @__PURE__ */ jsx(Button, { ...getSelectorButtonProps(), children: selectorIcon })
        ] })
      }
    ),
    disableAnimation ? popoverContent : /* @__PURE__ */ jsx(AnimatePresence, { children: popoverContent })
  ] });
}
var autocomplete_default = forwardRef(Autocomplete);
Autocomplete.displayName = "NextUI.Autocomplete";

export {
  autocomplete_default
};
